import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { Checkbox } from '@shared/checkbox/checkbox.model';

@Component({
  selector: 'mojo-checkboxes',
  templateUrl: 'checkbox.component.html',
  styleUrls: ['checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent {
  @Input() set checkboxes(value: Checkbox[]) {
    this.checkboxesArray = [...value];
    this.checkboxesArray.forEach((checkbox: Checkbox) => {
      if (!this.form.get(checkbox.value)) {
        this.form.addControl(checkbox.value, new UntypedFormControl(checkbox.selected));
      }
      const formControl = this.form.get(checkbox.value);
      if (!!formControl) {
        formControl.setValue(checkbox.selected);
      }
    });
  }

  get checkboxes(): Checkbox[] {
    return this.checkboxesArray;
  }

  @Output()
  checkboxesChange = new EventEmitter<Checkbox[]>();

  checkboxesArray: Checkbox[];
  form: UntypedFormGroup = new UntypedFormGroup({});

  updateCheckbox(selectedCheckbox: Checkbox) {
    const foundCheckbox = this.checkboxes.find(
      (checkbox) => checkbox.value === selectedCheckbox.value,
    );
    foundCheckbox.selected = !foundCheckbox.selected;
    this.checkboxesChange.emit(this.checkboxes);
  }
}
